import { getRegisterComponent } from '@/util/getFileComponent'

export default class RegisterFormTab {
  constructor({
    step,
    title = '',
    icon = '',
    // For path/regulator.vue
    pathName = '',
    regulator = '',
    // For custom component
    component = null,
  }) {
    // Number
    this.step = step
    this.title = title ?? ''
    this.icon = icon ?? ''
    // null -> disabled tab
    this.component =
      component !== null ? component : pathName?.length > 0 ? getRegisterComponent(pathName, regulator) : null
  }
}
